import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { Alert } from '@/components/common/Alert';
import { useTranslation } from 'react-i18next';

export const ErrorPage = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  let errorTitle = t('error.oops');
  let errorMessage = t('error.unexpected');
  let statusCode: number | null = null;

  if (isRouteErrorResponse(error)) {
    statusCode = error.status;
    errorTitle = t('error.errorWithStatus', { status: error.status });
    errorMessage = error.statusText || error.data?.message || errorMessage;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      background: '#f5f5f5'
    }}>
      <div style={{
        maxWidth: '600px',
        width: '100%',
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        textAlign: 'center'
      }}>
        {statusCode && (
          <div style={{
            fontSize: '72px',
            fontWeight: 700,
            color: '#8B204E',
            marginBottom: '16px',
            lineHeight: 1
          }}>
            {statusCode}
          </div>
        )}
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: 600,
          marginBottom: '16px',
          color: '#333'
        }}>
          {errorTitle}
        </h1>
        
        <Alert
          type="error"
          message={errorMessage}
        />

        {process.env.NODE_ENV === 'development' && error != null && (
          <details style={{
            marginTop: '20px',
            padding: '16px',
            background: '#f9f9f9',
            borderRadius: '8px',
            fontSize: '12px',
            fontFamily: 'monospace',
            overflow: 'auto',
            maxHeight: '300px',
            textAlign: 'left'
          }}>
            <summary style={{ cursor: 'pointer', marginBottom: '8px', fontWeight: 600 }}>
              {t('error.technicalDetails')}
            </summary>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {error instanceof Error ? error.stack : JSON.stringify(error, null, 2)}
            </pre>
          </details>
        )}

        <div style={{ marginTop: '24px', display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Link
            to="/"
            style={{
              padding: '12px 24px',
              background: '#8B204E',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 600,
              textDecoration: 'none',
              display: 'inline-block'
            }}
          >
            {t('error.backHome')}
          </Link>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '12px 24px',
              background: 'white',
              color: '#8B204E',
              border: '1px solid #8B204E',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 600
            }}
          >
            {t('error.previousPage')}
          </button>
        </div>
      </div>
    </div>
  );
};
